/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 我能兑换商品
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  condition: good.CommodityCondition,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: good.Page<good.CommodityDto>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/good/commodities/exchange/mine`,
    data: condition,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
